// Module
var code = "<md-button class=\"md-icon-button md-primary show-button margin-0\" ng-click=\"$ctrl.onShowPanel($event)\"> <md-icon md-svg-icon=\"show\"></md-icon> <span class=\"br-body-2 margin-left-5\" translate>Show columns</span> </md-button> ";
// Exports
export default code;